export class CompanyDto {
    id?: number;
    isActive?: boolean;
    createdAt?: string;
    createdBy?: string;
    updatedAt?: string;
    updatedBy?: string;

    companyIdSync?: number;
    companyCode?: string;
    companyName?: string;
    companyNameAlt?: string;
    useDefaultCategory?: boolean | "A" | "M";

    jobSource: JobSource = new JobSource();
}

export class JobSource {
    sheKpi: boolean = false;
    pi: boolean = false;
    dataWarehouse: boolean = false;
}
